export function parseMoneyToCents(value) {
  const input = value.trim().replace(/\s|R\$/g, '')
  if (!input) return null

  let normalized
  if (input.includes(',')) {
    normalized = input.replaceAll('.', '').replace(',', '.')
  } else if (/^\d+\.\d{1,2}$/.test(input)) {
    normalized = input
  } else {
    normalized = input.replaceAll('.', '')
  }

  if (!/^\d+(?:\.\d{1,2})?$/.test(normalized)) return null

  const [units, decimal = ''] = normalized.split('.')
  const cents = Number(units) * 100 + Number(decimal.padEnd(2, '0'))
  return Number.isSafeInteger(cents) ? cents : null
}

export function formatMoneyFromCents(value) {
  const cents = Number.parseInt(value, 10)
  if (!Number.isSafeInteger(cents) || cents < 0) return null

  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(cents / 100)
}
